
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best boat cruises in Goa with stunning views, live entertainment, and delicious food aboard comfortable boats.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover Goa’s top boat cruises, offering beautiful river views, great dining, and a relaxing experience for all. Ideal for fun outings with friends or family.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy a memorable time on Goa’s best boat cruises, featuring scenic views, tasty food, and live music. Perfect for a special day out with loved ones.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'goa boat cruise, goa boat cruise price, goa boat cruise tickets, goa boat cruise panjim, south goa boat cruise, sunset boat cruise goa, evening boat cruise goa',
        },
    
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],
    
      title: 'Goa Boat Cruise - Goa Boat Cruise Tickets and price',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/goa-boat-cruise`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/goa-boat-cruise`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/goa-boat-cruise`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Goa Boat Cruise - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Boat Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/goa-boat-cruise",
        "url": "https://www.goa.app/goa-boat-cruise",
        "name": "Goa Boat Cruise",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-27T08%3A06%3A09.155Z2021-11-05T11_36_41.904Zmandovi-travel-2-%281%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=TygCwmICPG5NYbsp9DFHAldaRSnYby01WuDXTIjlER5%2B%2FT9eSQGyZouhOcaItvEkEu6rH6uuVbmnZB64yCkJh2LC2C98jtUtx206xqBa%2BTWXi867E3Ai%2BVYf%2FAWLjC7ZumUiTC2XnGjZ23V4G%2F1Ox9IG0E4QnSrd%2B4E097w3t0xTFDLHPHGxxZTaUnBowxTRz010E73E%2FDNGT3TIlLMyAxNHX8dhQA1x5mH%2FK38IhrIJMUVUomdvqg8LtHiYx4ukqntkIoVdtPnr0%2FiJVpfmH7uBUI3wj1%2BSNOsYYcP%2BpXc%2BoIYsHc%2F9EPxjj31AgjKilzHQbbCnybUU%2FmMFPgTNdg%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Goa Boat Cruise offers a memorable experience with scenic views, lively entertainment, and great vibes. Ideal for celebrations or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while partying along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/goa-boat-cruise/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/goa-boat-cruise"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a Goa Boat Cruise through online platforms or by contacting local operators. Booking in advance, especially during peak season, is recommended to secure your spot."
  }
},
{
  "@type": "Question",
  "name": "What is included in a Goa Boat Cruise package?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Goa Boat Cruise packages typically include the cruise, crew, and basic amenities. Some packages offer extras like meals, beverages, and entertainment on board."
  }
},
{
  "@type": "Question",
  "name": "What should I wear for a Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It’s recommended to wear comfortable, smart casual attire. Dress for the weather and bring swimwear if you plan to take a dip or engage in water activities."
  }
},
{
  "@type": "Question",
  "name": "How long can I enjoy the Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Goa Boat Cruises can last anywhere from a couple of hours to a full day, depending on the package. Longer cruises for special occasions can often be arranged."
  }
},
{
  "@type": "Question",
  "name": "Can I customize the experience on a Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators allow customization for special occasions such as birthdays or anniversaries. You can add elements like decorations, meals, and entertainment."
  }
},
{
  "@type": "Question",
  "name": "Are meals and drinks included in the Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Goa Boat Cruises include meals and drinks, while others may offer them as an optional add-on. It's best to confirm with the cruise provider when booking."
  }
},
{
  "@type": "Question",
  "name": "What is the price range for Goa Boat Cruises?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Prices for Goa Boat Cruises typically start from ₹500 and can vary based on the duration, inclusions, and amenities offered."
  }
},
{
  "@type": "Question",
  "name": "Can I book a Goa Boat Cruise for a special occasion?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, Goa Boat Cruises are perfect for special occasions like anniversaries or celebrations. Many operators offer tailor-made packages for such events."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to book a Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time to book a Goa Boat Cruise is between November and February when the weather is pleasant. However, cruises are available year-round for a memorable experience."
  }
},
{
  "@type": "Question",
  "name": "Can I bring my own food and drinks on a Goa Boat Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Goa Boat Cruise operators allow you to bring your own food and beverages, while others provide catering services. It's advisable to check with the provider in advance."
  }
},
{
  "@type": "Question",
  "name": "Are Goa Boat Cruises suitable for water sports?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many Goa Boat Cruises offer additional water sports activities such as jet skiing and fishing. You can inquire about these options when booking your cruise."
  }
}


        ]
      }
    ]
  };
},

};


  